interface IndianCities {
  [key: string]: string[];
}

export const indianCities: IndianCities = {
  "Andaman and Nicobar Islands": ["Port Blair"],
  "Andhra Pradesh": [
    "Visakhapatnam",
    "Vijayawada",
    "Guntur",
    "Nellore",
    "Kurnool",
    "Rajahmundry",
    "Tirupati",
    "Kakinada",
    "Kadapa",
    "Anantapur",
    "Vizianagaram",
    "Eluru",
    "Ongole",
    "Nandyal",
    "Machilipatnam",
    "Adoni",
    "Tenali",
    "Proddatur",
    "Chittoor",
    "Hindupur",
  ],
  "Arunachal Pradesh": [
    "Itanagar",
    "Naharlagun",
    "Pasighat",
    "Roing",
    "Tezu",
    "Ziro",
    "Aalo",
    "Tawang",
    "Bomdila",
    "Along",
    "Daporijo",
    "Namsai",
    "Seppa",
    "Changlang",
  ],
  Assam: [
    "Guwahati",
    "Silchar",
    "Dibrugarh",
    "Jorhat",
    "Nagaon",
    "Tinsukia",
    "Tezpur",
    "Bongaigaon",
    "Karimganj",
    "Diphu",
    "Dhubri",
    "North Lakhimpur",
    "Jorhat",
    "Sivasagar",
    "Goalpara",
    "Barpeta",
    "Lanka",
    "Nalbari",
    "Mangaldoi",
    "Dhekiajuli",
    "Hailakandi",
  ],
  Bihar: [
    "Patna",
    "Gaya",
    "Bhagalpur",
    "Muzaffarpur",
    "Darbhanga",
    "Arrah",
    "Bihar Sharif",
    "Hajipur",
    "Begusarai",
    "Munger",
    "Purnia",
    "Saharsa",
    "Sasaram",
    "Danapur",
    "Chapra",
    "Muzaffarpur",
    "Dehri",
    "Motihari",
    "Phulwari Sharif",
    "Sonepur",
    "Siwan",
  ],
  Chandigarh: ["Chandigarh"],
  Chhattisgarh: [
    "Raipur",
    "Bhilai",
    "Durg",
    "Bilaspur",
    "Korba",
    "Raigarh",
    "Jagdalpur",
    "Raipur",
    "Ambikapur",
    "Mahasamund",
    "Dhamtari",
    "Rajnandgaon",
    "Jashpur",
    "Baloda Bazar",
    "Kanker",
    "Bhatapara",
    "Bilaspur",
    "Korba",
    "Rajnandgaon",
    "Ambikapur",
  ],
  "Dadra and Nagar Haveli and Daman and Diu": ["Daman", "Silvassa"],
  Delhi: ["Delhi"],
  Goa: ["Panaji", "Margao", "Vasco da Gama"],
  Gujarat: [
    "Ahmedabad",
    "Surat",
    "Vadodara",
    "Rajkot",
    "Bhavnagar",
    "Jamnagar",
    "Junagadh",
    "Gandhinagar",
    "Nadiad",
    "Morbi",
    "Surendranagar",
    "Gandhidham",
    "Veraval",
    "Navsari",
    "Bharuch",
    "Anand",
    "Porbandar",
    "Godhra",
    "Botad",
    "Sidhpur",
    "Bhuj",
  ],
  Haryana: [
    "Faridabad",
    "Gurgaon",
    "Panipat",
    "Ambala",
    "Yamunanagar",
    "Rohtak",
    "Hisar",
    "Karnal",
    "Sonipat",
    "Panchkula",
    "Bhiwani",
    "Sirsa",
    "Bahadurgarh",
    "Jind",
    "Thanesar",
    "Kaithal",
    "Rewari",
    "Palwal",
    "Fatehabad",
    "Gohana",
  ],
  "Himachal Pradesh": [
    "Shimla",
    "Mandi",
    "Solan",
    "Dharamshala",
    "Kangra",
    "Palampur",
    "Baddi",
    "Nahan",
    "Una",
    "Nurpur",
    "Hamirpur",
    "Chamba",
    "Mehatpur Basdehra",
    "Sundarnagar",
    "Bilaspur",
    "Kullu",
    "Mandi",
    "Nagrota Bagwan",
    "Rampur",
    "Rohru",
  ],
  "Jammu and Kashmir": [
    "Srinagar",
    "Jammu",
    "Anantnag",
    "Baramulla",
    "Kathua",
    "Sopore",
    "Samba",
    "Udhampur",
    "Kargil",
    "Leh",
    "Pulwama",
    "Handwara",
    "Pahalgam",
    "Ganderbal",
    "Kulgam",
    "Kishtwar",
    "Shopian",
    "Budgam",
    "Doda",
    "Kupwara",
  ],
  Jharkhand: [
    "Ranchi",
    "Jamshedpur",
    "Dhanbad",
    "Bokaro",
    "Deoghar",
    "Hazaribagh",
    "Ranchi",
    "Dhanbad",
    "Jamshedpur",
    "Bokaro",
    "Hazaribagh",
    "Ramgarh",
    "Giridih",
    "Medininagar (Daltonganj)",
    "Chirkunda",
    "Phusro",
    "Jhumri Tilaiya",
    "Gumla",
    "Barkakana",
    "Chaibasa",
  ],
  Karnataka: [
    "Bangalore",
    "Hubli-Dharwad",
    "Mysore",
    "Belgaum",
    "Mangalore",
    "Gulbarga",
    "Davanagere",
    "Bellary",
    "Bijapur",
    "Shimoga",
    "Tumkur",
    "Raichur",
    "Bidar",
    "Hospet",
    "Hassan",
    "Gadag-Betigeri",
    "Udupi",
    "Robertson Pet",
    "Bijapur",
    "Bhadravati",
  ],
  Kerala: [
    "Thiruvananthapuram",
    "Kochi",
    "Kozhikode",
    "Kollam",
    "Thrissur",
    "Palakkad",
    "Alappuzha",
    "Malappuram",
    "Ponnani",
    "Thalassery",
    "Kannur",
    "Tirur",
    "Kasaragod",
    "Kottayam",
    "Pathanamthitta",
    "Kottarakkara",
    "Aluva",
    "Thrissur",
    "Kayamkulam",
    "Neyyattinkara",
    "Payyannur",
  ],
  Lakshadweep: ["Kavaratti"],
  "Madhya Pradesh": [
    "Indore",
    "Bhopal",
    "Jabalpur",
    "Gwalior",
    "Ujjain",
    "Sagar",
    "Dewas",
    "Satna",
    "Ratlam",
    "Rewa",
    "Murwara (Katni)",
    "Singrauli",
    "Burhanpur",
    "Khandwa",
    "Morena",
    "Guna",
    "Betul",
    "Sehore",
    "Mandsaur",
    "Damoh",
    "Khargone",
  ],
  Maharashtra: [
    "Mumbai",
    "Pune",
    "Nagpur",
    "Thane",
    "Nashik",
    "Aurangabad",
    "Solapur",
    "Kalyan-Dombivli",
    "Vasai-Virar",
    "Bhiwandi",
    "Amravati",
    "Nanded",
    "Kolhapur",
    "Sangli",
    "Malegaon",
    "Jalgaon",
    "Akola",
    "Latur",
    "Ahmednagar",
    "Dhule",
    "Ichalkaranji",
    "Chandrapur",
    "Parbhani",
    "Jalna",
    "Bhusawal",
    "Navi Mumbai",
    "Panvel",
  ],
  Manipur: [
    "Imphal",
    "Thoubal",
    "Bishnupur",
    "Churachandpur",
    "Ukhrul",
    "Kakching",
    "Lilong",
    "Mayang Imphal",
    "Senapati",
    "Kangpokpi",
    "Jiribam",
    "Moreh",
    "Lamphelpat",
    "Kumbi",
    "Kakching",
    "Lilong",
  ],
  Meghalaya: ["Shillong", "Tura", "Nongstoin", "Jowai", "Baghmara"],
  Mizoram: [
    "Aizawl",
    "Lunglei",
    "Saiha",
    "Champhai",
    "Serchhip",
    "Kolasib",
    "Mamit",
    "Saitual",
    "Khawzawl",
    "Biate",
    "North Vanlaiphai",
    "Lengpui",
    "Demagiri",
    "Hnahthial",
    "Tuipang",
  ],
  Nagaland: ["Dimapur", "Kohima", "Mokokchung", "Tuensang", "Zunheboto"],
  Odisha: [
    "Bhubaneswar",
    "Cuttack",
    "Rourkela",
    "Brahmapur",
    "Sambalpur",
    "Puri",
    "Balasore",
    "Bhadrak",
    "Baripada",
    "Jharsuguda",
    "Jeypore",
    "Baleshwar",
    "Bargarh",
    "Bhawanipatna",
    "Rayagada",
    "Puri",
    "Balasore",
    "Bhadrak",
    "Baripada",
    "Jharsuguda",
    "Jeypore",
    "Baleshwar",
    "Bargarh",
    "Bhawanipatna",
    "Rayagada",
  ],
  Puducherry: ["Puducherry", "Karaikal", "Yanam", "Mahe"],
  Punjab: [
    "Ludhiana",
    "Amritsar",
    "Jalandhar",
    "Patiala",
    "Bathinda",
    "Mohali",
    "Pathankot",
    "Hoshiarpur",
    "Batala",
    "Moga",
    "Khanna",
    "Malerkotla",
    "Gurdaspur",
    "Sangrur",
    "Phagwara",
    "Abohar",
    "Firozpur",
    "Rajpura",
    "Kapurthala",
    "Faridkot",
  ],
  Rajasthan: [
    "Jaipur",
    "Jodhpur",
    "Kota",
    "Bikaner",
    "Ajmer",
    "Udaipur",
    "Bhilwara",
    "Alwar",
    "Bharatpur",
    "Sikar",
    "Pali",
    "Sri Ganganagar",
    "Hanumangarh",
    "Tonk",
    "Jhunjhunu",
    "Kishangarh",
    "Barmer",
    "Nagaur",
    "Makrana",
    "Sawai Madhopur",
  ],
  Sikkim: ["Gangtok", "Namchi", "Mangan", "Jorethang"],
  "Tamil Nadu": [
    "Chennai",
    "Coimbatore",
    "Madurai",
    "Tiruchirappalli",
    "Tiruppur",
    "Salem",
    "Erode",
    "Tirunelveli",
    "Vellore",
    "Thoothukudi",
    "Dindigul",
    "Thanjavur",
    "Tiruvannamalai",
    "Nagercoil",
    "Hosur",
    "Kancheepuram",
    "Kumarapalayam",
    "Karaikkudi",
    "Neyveli",
    "Cuddalore",
  ],
  Telangana: [
    "Hyderabad",
    "Warangal",
    "Nizamabad",
    "Khammam",
    "Karimnagar",
    "Ramagundam",
    "Mahbubnagar",
    "Mancherial",
    "Nalgonda",
    "Adilabad",
    "Suryapet",
    "Jagtial",
    "Miryalaguda",
    "Kothagudem",
    "Siddipet",
    "Kamareddy",
    "Wanaparthy",
    "Nagarkurnool",
  ],
  Tripura: ["Agartala", "Udaipur", "Dharmanagar", "Kailasahar"],
  "Uttar Pradesh": [
    "Lucknow",
    "Kanpur",
    "Ghaziabad",
    "Agra",
    "Meerut",
    "Varanasi",
    "Prayagraj",
    "Bareilly",
    "Aligarh",
    "Moradabad",
    "Saharanpur",
    "Gorakhpur",
    "Faizabad",
    "Jhansi",
    "Muzaffarnagar",
    "Mathura",
    "Noida",
    "Shahjahanpur",
    "Rampur",
    "Farrukhabad",
    "Hapur",
  ],
  Uttarakhand: [
    "Dehradun",
    "Haridwar",
    "Roorkee",
    "Haldwani",
    "Rudrapur",
    "Kashipur",
    "Rishikesh",
    "Ramnagar",
    "Kotdwara",
    "Rudraprayag",
    "Pithoragarh",
    "Nainital",
    "Chamoli Gopeshwar",
    "Bageshwar",
    "Almora",
    "Srinagar",
    "Mussoorie",
    "Tehri",
  ],
  "West Bengal": [
    "Kolkata",
    "Howrah",
    "Durgapur",
    "Asansol",
    "Siliguri",
    "Maheshtala",
    "Rajpur Sonarpur",
    "South Dumdum",
    "Panihati",
    "Kamarhati",
    "Bhatpara",
    "Bidhannagar",
    "Barasat",
    "Kulti",
    "Bally",
    "North Dumdum",
    "Baranagar",
    "Haldia",
    "Madhyamgram",
    "Basirhat",
  ],
};
